import { UrlObject } from "url";

type Url = string | UrlObject;

export function buildLocalizedUrl(
  url: Url,
  country: string,
  language: string,
  skipLocalePrefix = false
): Url {
  if (skipLocalePrefix) return url;

  const prefixPath = (path: string) => {
    const trimmedPath = path.startsWith("/") ? path : `/${path}`;
    return `/${country}/${language}${trimmedPath}`;
  };

  const cleanPath = (path: string) => {
    if (path.includes("//")) {
      return path.replace("//", "/");
    }

    return path;
  };

  if (typeof url === "string") {
    return cleanPath(prefixPath(url));
  }

  return {
    ...url,
    pathname: url.pathname ? cleanPath(prefixPath(url.pathname)) : undefined,
  };
}
